import { useMutation } from '@apollo/client'
import { REACTIVATE_SUBSCRIPTION_MUTATION } from '../gql/mutations'
import { t } from '../utils'
import { useAuth } from '../utils/auth'
import { User } from '../__generated__/graphql'
import { useToasts } from './complex/Toast'

const ReactivateBlock: React.FC = () => {
  const { currentUser, setCurrentUser } = useAuth()
  const { addToast } = useToasts()
  const currentPlan = currentUser?.currentPlan

  const [reactivateSubscription] = useMutation(
    REACTIVATE_SUBSCRIPTION_MUTATION,
    {
      onCompleted: ({ reactivateSubscriptionPlan: { user } }) => {
        setCurrentUser(user as User)
        addToast(t('Subscription was activated successfully!'))
      }
    }
  )
  const isFuture = function (date) {
    const today = new Date()
    const secondDate = new Date(date)
    return today.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)
  }
  return (
    <>
      {currentUser &&
        currentPlan &&
        !!currentPlan.price &&
        isFuture(currentUser.canceledAt) && (
          <div
            className="adminMessageBlock"
            onClick={() => reactivateSubscription()}
          >
            {t('Reactivate my account')}
          </div>
        )}
    </>
  )
}

export default ReactivateBlock
